
$(window).on("scroll", function() {
	var scrollPosition = $(window).scrollTop();
	var windH = $(window).height();



	$(".fade__Up,.fade__in,.fade__left,.fade__right").each(function(i) {
		var thisH = $(this).offset().top;
		if(thisH-windH*0.75 < scrollPosition){
				$(this).addClass("fadeUp__on");
		}
	});

	$(".mask__left").each(function(i) {
		var thisH = $(this).offset().top;
		if(thisH-windH*0.75 < scrollPosition){
				$(this).addClass("mask__on");
		}else{
				$(this).removeClass("mask__on");
		}
	});

});

$(function(){
	$(".trans").hover(function(){
		$(this).fadeTo(150, 0.6); 
	},function(){
		$(this).fadeTo(150, 1.0); 
	});
});

$(function(){
    // #で始まるアンカーをクリックした場合に処理
    $('.anchorlink').click(function() {
       // スクロールの速度
       var speed = 400; // ミリ秒
       // アンカーの値取得
       var href= $(this).attr("href");
       // 移動先を取得
       var target = $(href == "#" || href == "" ? 'html' : href);
       // 移動先を数値で取得
       var position = target.offset().top;
       // スムーススクロール
       $('body,html').animate({scrollTop:position}, speed, 'swing');
       return false;
    });
 });
 $(document).ready(function() {
     var pagetop = $('.pagetop');
     $(window).scroll(function () {
         if ($(this).scrollTop() > 700) {
             pagetop.fadeIn();
         } else {
             pagetop.fadeOut();
         }
     });
     pagetop.click(function () {
         $('body, html').animate({ scrollTop: 0 }, 1000);
         return false;
     });
 });


 $( window ).scroll(function(){
  var scrollHeight = $( window ).scrollTop();
//var section0 = $('.mainslide-wrap').outerHeight();
  if( scrollHeight > 100 ){
      $('#scroll').addClass('UpMove');
  }else{
  }
});